// Components
import SocialMediaReviewAssociateTableSkeleton from "../skeletons/SocialMediaReviewAssociateTableSkeleton";
import SocialMediaReviewAssociate from "../associate/SocialMediaReviewAssociate";

// Helpers
import { getTabContent } from "../helpers";

// Types
import { IUserReview, TSelectionItem } from "../interfaces";

type TSocialMediaReviewAssociateTableProps = {
	isLoading: boolean;
	options: string[];
	indexTab: number;
	positionsContent: IUserReview[];
	locationId: string;
	onDemand?: boolean;
	selectedItem: TSelectionItem | null;
	isDataPresent: boolean;
};

export default function SocialMediaReviewAssociateTable(props: Readonly<TSocialMediaReviewAssociateTableProps>) {
	const { isLoading, options, indexTab, positionsContent, locationId, onDemand, isDataPresent, selectedItem } = props;

	if (isLoading || !selectedItem) {
		return <SocialMediaReviewAssociateTableSkeleton />;
	}

	const tabContent = getTabContent(options, indexTab, positionsContent);
	if (!tabContent) {
		return null;
	}

	return (
		<SocialMediaReviewAssociate
			key={tabContent.positionName}
			locationId={locationId}
			onDemand={onDemand}
			positionName={tabContent.positionName}
			selectedItem={selectedItem}
			isDataPresent={isDataPresent}
			columns={tabContent.columns}
			tabName={options[indexTab]}
			rows={tabContent.rows}
		/>
	);
}
